/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MovementType(props) {
	
	const { t } = useTranslation();

	return (
		<BasicCrudScreenType
			id={"MovementType"}
			headerTitle={t("term.movementType")}
			table={"MovementType"}
			view={"VwMovementType"}
			buttonsInFrontOfSearch
		/>
	);
}

export default MovementType;
